import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { CatalogoDeTelas } from '@/features/cadastros/componentes/CadastrosGlobais';
import { rotaDaPlataforma } from '@/features/permissoes/guardas';

const busca = z.object({
  busca: z.string().optional().catch(undefined),
  cursor: z.string().optional().catch(undefined),
});

/** Catálogo global de telas (spec 014, CA-04), composto com o cadastro genérico (spec 004). */
export const Route = createFileRoute('/_autenticado/plataforma/telas')({
  ...rotaDaPlataforma('Telas'),
  validateSearch: busca,
  component: Pagina,
});

function Pagina() {
  const filtros = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <CatalogoDeTelas
      filtros={filtros}
      aoMudarFiltros={(novos) => {
        void navigate({ search: novos, replace: true });
      }}
    />
  );
}
